export class Grupo {
    id: string;
    descricao: string;
    quantidade: number;
    code: number;
    name: string;
}
